import { render, staticRenderFns } from "./link-back.vue?vue&type=template&id=09863ffd&scoped=true&"
import script from "./link-back.vue?vue&type=script&lang=js&"
export * from "./link-back.vue?vue&type=script&lang=js&"
import style0 from "./link-back.vue?vue&type=style&index=0&id=09863ffd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09863ffd",
  null
  
)

export default component.exports